import $ from 'jquery';
import { CLASSES } from '@/scripts/helpers/constants';
import { addedLazyLoadImages } from '@/scripts/helpers/lazyload';
import { bindJQuery } from '@/scripts/helpers/library';
import { accordion } from '../modules/containers/accordion/index';

const ACTIVE = 'is-active';

const initStates = () => {
  const select = $('.states');

  select.on('click', function() {
    select.toggleClass(ACTIVE);
  });
}

$(document).ready(() => {
  bindJQuery();
  addedLazyLoadImages();
  accordion();
  initStates();

  $('.js-view-all').on('click', () => {
    $('.catalog__item').removeClass(CLASSES.IS_HIDDEN);
    $('.section-actions').addClass(CLASSES.IS_HIDDEN);
    if ($('*').is('.pagination')) {
      $('.pagination').removeClass(CLASSES.IS_HIDDEN);
    }
  });
});
